import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import Icon from "../icon";

export const icons = {
  //exported for tests
  alert: "exclamation-triangle",
  comment: "info-circle",
  success: "check-circle",
  warning: "bell",
};

export const colours = {
  //exported for tests
  alert: "danger",
  comment: "secondary",
  success: "success",
  warning: "warning",
};

class WarningBox extends React.Component {
  render() {
    return (
      <Alert
        className={classNames(
          "d-flex justify-content-between text-align-center mx-auto",
          this.props.className,
        )}
        color={colours[this.props.type]}
      >
        <div className="warning-content">{this.props.children}</div>
        <Icon icon={icons[this.props.type]} />
      </Alert>
    );
  }
}

WarningBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  type: PropTypes.oneOf(["alert", "comment", "success", "warning"]),
};

WarningBox.defaultProps = {
  type: "alert",
};

export default WarningBox;
